export const SELECT_HEADING = 'Выберите из списка';
